import AnonymousAgent from '../api/AnonymousAgent'
import {
  IInteractiveTemplateGetFormRequest,
  IInteractiveTemplatePostFormRequest,
} from '../models/InteractiveTemplate'

class InteractiveTemplateService {
  getForm = async (formKey: string) => {
    const request: IInteractiveTemplateGetFormRequest = {
      formKey: formKey,
    }
    return AnonymousAgent.InteractiveTemplate.getForm(request)
  }

  postForm = async (request: IInteractiveTemplatePostFormRequest) => {
    return AnonymousAgent.InteractiveTemplate.postForm(request)
  }
}

export default new InteractiveTemplateService()
